import { SearchCriteria } from "./search-criteria";

export class GetGiftCardBranchesSearchCriteria extends SearchCriteria {
    public GiftCardInformationId: number;
}
